import { Dispatch, SetStateAction, createContext } from "react";
import { FilterBody, FilterProps } from "../../../../../hooks/filter/typing";

const DashboardReportFolioContext = createContext<{
    filterData: FilterBody
    setFilterPayload: Dispatch<SetStateAction<FilterProps>>
    isLoading: boolean
    uuid: string
    getDetailInform: ({ query }: { query?: string; }) => Promise<void>
}>(Object({}))

export { DashboardReportFolioContext }
